export default __webpack_public_path__ + "static/media/stadium-bg-md.23845559.png";